import {
  AuthActions,
  Selectors,
  SubscriptionsState,
  useWidgetDispatch,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {EmailPreferences} from '@eCommerce/frontend-legacy-shared-library-native/lib/typescript/models/Profile';
import React from 'react';

import SubscriptionsModule from 'components/SubscriptionsModule';
import {AdobeEvent, useTrackEvent} from 'hooks/useTrackEvent';

const ConnectedSubscriptionsModule = ({setTabToProfile}) => {
  const isSubscribed = useWidgetState(
    Selectors.isSubscribedToEmailsSelector
  ) as boolean;
  const statusOpt = useWidgetState(
    Selectors.subscriptionsOptStatusSelector
  ) as SubscriptionsState;

  const emailPreferences = useWidgetState(
    Selectors.emailPreferencesSelector
  ) as EmailPreferences;

  const isInvalid = !emailPreferences?.email;

  const widgetDispatch = useWidgetDispatch();
  const {trackAdobeEvent} = useTrackEvent();

  const handleSubscribedChecked = (checked: boolean) => {
    widgetDispatch(AuthActions.optGuestEmail({optIn: checked}));
    trackAdobeEvent({
      event: AdobeEvent.click,
      click: {name: 'my account caesars email'},
      contact: {
        email: checked ? '1' : '0',
      },
    });
  };

  return (
    <SubscriptionsModule
      isSubscribed={isSubscribed}
      isDisabled={statusOpt.isLoading}
      onSubscribedChecked={handleSubscribedChecked}
      isInvalid={isInvalid}
      setTabToProfile={setTabToProfile}
    />
  );
};

export default ConnectedSubscriptionsModule;
